import { useTheme } from '@mui/material/styles';
import { Box, Typography } from '../material';
import useGridApiContext from 'libs/mui/data-grid/hooks/useGripApiContext';

const CXDataGridFooter: React.FC<{ displayedRowCount: number }> = ({ displayedRowCount }) => {
  const { palette } = useTheme();
  const gridApi = useGridApiContext();
  const visibleRows = gridApi.state.rows.dataRowIds.length;
  const totalRows = displayedRowCount || gridApi.state.rows.totalRowCount;
  return (
    <Box p={1.5}>
      <Typography variant="body4" color={palette.Text.SubHeadline}>
        Total Rows: {visibleRows} of {totalRows}
      </Typography>
    </Box>
  );
};

export default CXDataGridFooter;
